import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
export const updateOrderItemPrice = createAsyncThunk(
  "updateOrderItemPrice/update",
  async ({ medicineId, buying_price, selling_price }, { rejectWithValue }) => {
    if (!medicineId) return rejectWithValue("No medicine ID");
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.put(
        `${process.env.REACT_APP_API_URL}/api/v1/pharmacy/medicines/${medicineId}`,
        { buying_price, selling_price },
      );
      if (response?.data?.status === true) {
        toast.success(i18n.t("pharmacy.toast.priceUpdated"));
      }
      return response.data;
    } catch (error) {
      const msg = error?.response?.data?.message || i18n.t("pharmacy.toast.failedToUpdatePrice");
      toast.error(msg);
      return rejectWithValue(msg);
    }
  },
);
